import { App, KernelRouteEndpoint, KernelRoute } from "../../../kernel/kernel";
import raf from "raf";

/**
 * Login route
 *
 * @extends KernelRoute
 */
class FormRoute extends KernelRoute {

    /**
     * When the user hits the index page, show the index page
     */
    @KernelRouteEndpoint("/deleted(/)")
    completedRoute (params) {
        System.import("./deleted").then(View => {
            const view = new View.default();
            raf(_ => App.contentRegion.show(view));
        });
        
    }
}

export default FormRoute;



// WEBPACK FOOTER //
// ./public/domain/views/deleted/deleted.route.js